import { cn, PropsWithClassName } from "kz-ui-sdk";

interface TextGradientProps extends PropsWithClassName {
  className?: string;
  text: string;
  variant?: TextGradientVariant;
  classes?: {
    label?: string;
    labelOverlay?: string;
  };
  dir?: "ltr" | "rtl";
}

type TextGradientVariant = "primary" | "secondary";

const TextGradient = ({ className, text, variant = "primary", classes, dir = "ltr" }: TextGradientProps) => {
  return (
    <div className={cn("relative h-[35px] w-full", className)}>
      <span
        className={cn(
          "absolute start-1/2 top-[1px] will-change-transform -translate-start-1/2",
          "ps-[0.5px] pt-[1px] text-2xl font-bold leading-8 [-webkit-text-stroke:0.5px_currentColor] [text-shadow:0px_2px_0px_rgba(0,0,0,0.20),0px_1px_0px_currentColor]",
          VARIANTS[variant].label,
          classes?.label,
        )}
      >
        <span dir={dir}>{text}</span>
      </span>
      <span
        className={cn(
          "absolute start-1/2 top-0 will-change-transform -translate-start-1/2",
          "bg-clip-text text-2xl font-bold leading-8 text-transparent",
          VARIANTS[variant].labelOverlay,
          classes?.labelOverlay,
        )}
      >
        <span dir={dir}>{text}</span>
      </span>
    </div>
  );
};

const VARIANTS: Record<
  TextGradientVariant,
  {
    label: string;
    labelOverlay: string;
  }
> = {
  primary: {
    label: "text-darkBrand-600",
    labelOverlay: "bg-pageTitle",
  },
  secondary: {
    label: "text-darkBrand-600",
    labelOverlay: "bg-pageTitle",
  },
};

export default TextGradient;
